<div class="confirm-email-modal">
  <div class="modal-header">
    <h2 class="title">Confirm Email IDs</h2>
    <button type="button" class="close-btn" (click)="cancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <div class="field-grid">
      <div class="field-block">
        <span class="label">To</span>
        <div class="chips-row" aria-label="To recipients">
          <span *ngFor="let email of toChips" class="chip default-chip">
            <span class="chip-text">{{ email }}</span>
            <button type="button" class="chip-x" (click)="removeToChip(email)" aria-label="Remove">×</button>
          </span>
        </div>
      </div>

      <div class="field-block">
        <label class="label" for="to-email-input">Add To</label>
        <div class="input-wrap">
          <input
            id="to-email-input"
            type="email"
            class="email-input"
            [(ngModel)]="toInputValue"
            (keydown)="onInputKey('to', $event)"
            (blur)="onBlur('to')"
            placeholder="add more To recipients"
          />
        </div>
      </div>

      <div class="field-block">
        <span class="label">CC</span>
        <div class="chips-row" aria-label="CC recipients">
          <span *ngFor="let email of ccChips" class="chip default-chip">
            <span class="chip-text">{{ email }}</span>
            <button type="button" class="chip-x" (click)="removeCcChip(email)" aria-label="Remove">×</button>
          </span>
        </div>
      </div>

      <div class="field-block">
        <label class="label" for="cc-email-input">Add CC</label>
        <div class="input-wrap">
          <input
            id="cc-email-input"
            type="email"
            class="email-input"
            [(ngModel)]="ccInputValue"
            (keydown)="onInputKey('cc', $event)"
            (blur)="onBlur('cc')"
            placeholder="add more CC recipients"
          />
          <div *ngIf="errorMessage" class="error-text">{{ errorMessage }}</div>
          <div class="helper-text">Press Enter or comma to add an email.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="send()">Send</button>
  </div>
</div>
